const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const usdPrecise = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 4 });
const integer = new Intl.NumberFormat('en-US');

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return usd.format(value);
}

/** For unit costs that need sub-cent resolution (e.g. cost per visit). */
export function formatUnitCost(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return usdPrecise.format(value);
}

/** A unit cost in cents under a dollar ("1.24¢"), in dollars from a dollar up ("$1.20"). */
export function formatCents(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  if (value < 1) return `${(value * 100).toFixed(value < 0.1 ? 2 : 1)}¢`;
  return usd.format(value);
}

export function formatCount(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  return integer.format(value);
}

export function formatPercent(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${(value * 100).toFixed(digits)}%`;
}

/** "2026-06" → "Jun 2026" */
export function formatMonth(yearMonth: string): string {
  const [year, month] = yearMonth.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, 1)).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
